import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../../../objects/Context';
import './SettingsComponents.css';

function ProfileSettings() {
    const { user, setUser } = useContext(UserContext);
    const [name, setName] = useState(user.name || '');
    const [isNameChanged, setIsNameChanged] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    
    // Check if name has changed whenever name state updates
    useEffect(() => {
        setIsNameChanged(name !== (user.name || ''));
    }, [name, user.name]);
    
    function renameRole(role) {
        if (role === 'admin') return 'Admin';
        if (role === 'member') return 'Member';
        return 'N/A';
    }

    const handleSave = async () => {
        if (!isNameChanged || isUpdating) return;
        
        setIsUpdating(true);
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/users/update-name/${user.id}`, { newName: name }, { withCredentials: true });
            setUser(prevUser => ({...prevUser, name: name}));
            setIsNameChanged(false);
        } catch (error) {
            console.error('Error updating name:', error);
        } finally {
            setIsUpdating(false);
        }
    };
    
    return (
        <div className="settings-component">
            <div className="settings-header">
                <div className="settings-title-group">
                    <h1 className="settings-title">Personal Information</h1>
                    <h2 className="settings-subtitle">Update your personal profile information</h2>
                </div>
            </div>
            <div className="content">
                <div className="item-list">
                    <div className="text-item-label">
                        <div className="title">Name</div>
                        <div className="description">The name associated with your account</div>
                        <input className="text-item-value" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter your name"/>
                    </div>
                    <div className="text-item-label">
                        <div className="title">Email</div>
                        <div className="description">The email associated with your account</div>
                        <input className="text-item-value" type="text" value={user.email} disabled={true} placeholder="Enter your email"/>
                    </div>
                    <div className="text-item-label">
                        <div className="title">Role</div>
                        <div className="description">The role you have in your organization</div>
                        <input className="text-item-value" type="text" value={renameRole(user.orgRole)} disabled={true} placeholder="Enter your role"/>
                    </div>
                </div>
                <div className="button-container">
                    <button 
                        className="save-button" 
                        disabled={!isNameChanged || isUpdating}
                        onClick={handleSave}
                    >
                        {isUpdating ? 'Updating...' : 'Update Name'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ProfileSettings;